import React, { useContext, useEffect, useState, useRef } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Loader from "./common/loader";
import { UserContext } from "./contexts/UserContext";
import AuthService from "./services/auth-service";
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '@auth/authConfig';
import { useNavigate } from "react-router-dom";


const ProtectedRoute = () => {
  const { user, setUser } = useContext(UserContext);
  const token = AuthService.getToken();
  const accessToken = AuthService.getMSToken();
  const [loading, setLoading] = useState(true);
  const hasFetched = useRef(false);
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      let user = {};
      if (!hasFetched.current && token) {
        setLoading(true);
        user = await AuthService.getAuthData();
        if (!user) {
          setUser({});
          localStorage.clear();
          navigate("/login");
        }
        updateUserDetails(user);
        setLoading(false);
      } else if (!hasFetched.current && accessToken && accounts.length > 0) {
        setLoading(true);
        const account = accounts[0];
        const response = await instance.acquireTokenSilent({
          ...loginRequest,
          account,
        });
        if (response.accessToken) {
          const claims = response.idTokenClaims || {};
          const email = (claims.email || claims.preferred_username || '').toLowerCase();
          const fullName = (claims.name || '').trim();
          const [firstName = '', ...rest] = fullName.split(' ');
          const lastName = rest.join(' ');
          user = { email, firstName, lastName };
          updateUserDetails(user);
        } else {
          updateUserDetails({})
        }
        setLoading(false);
      } else if (!hasFetched.current) {
        updateUserDetails({})
      }
    };

    fetchUserData();
  }, [token, user.email]);

  const updateUserDetails = (user) => {
    setUser(user);
    setLoading(false);
    hasFetched.current = true;
  }

  if (loading) return <Loader />;

  return hasFetched.current && user.email ? <Outlet /> : <Navigate to="/login" replace />

};

export default ProtectedRoute;